import type { Component } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import type { FeatureRefs } from '../cssFeatures.types'
import type { PageTransitionsViewTransitionData } from './pageTransitions.types'

export const pageTransitionsViewTransition = createCssCompNode('pageTransitions', 'pageTransitionsViewTransition', {
	getDependencies: (component: Component, refs: FeatureRefs<'pageTransitions'>) => {
		const isMasterPage = component.type === 'Document'

		if (!isMasterPage) {
			return null
		}

		return {
			pageTransition: refs.pageTransition(component),
		}
	},
	toViewItem: (component, deps) => {
		if (!deps) {
			return null
		}

		const { pageTransition } = deps

		if (!pageTransition || pageTransition === 'none') {
			return null
		}

		return {
			transitionName: pageTransition,
		}
	},
})
